<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="artist-container">
    <div
      :style="backgroundImg"
      class="artist-banner">
      <div class="name-artist">
        <h1>{{ artist.artistName }}</h1>
      </div>
      <div class="btn-route">
        <i
          class="icon-arrow-left"
          @click="goToBack"/>
        <span>{{ nameRoute }}</span>
      </div>
    </div>
    <div class="breadcrumb hidden-xs-only">
      <el-breadcrumb separator-class="icon-bullet-icon">
        <el-breadcrumb-item :to="{ name: 'Home' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Artistas</el-breadcrumb-item>
        <el-breadcrumb-item>{{ artist.artistName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="grid-container">
      <el-row
        class="grid-content">
        <el-col
          :xs="24"
          :sm="7"
          :md="6"
          :lg="5"
          :xl="5"
          class="artist-description">
          <div class="div-img-artist">
            <div
              :style="profileImg"
              class="artist-img"/>
            <h1>{{ artist.artistName }}</h1>
          </div>
          <p v-html="artist.description"/>
          <b>Principales etiquetas</b>
          <!-- <span
            v-for="item in artistEvent"
            :key="item.id">
            {{ item.id }}
          </span>-->
          <!--<div class="tag-event">
            <span
              v-for="(index, tag) in artistsBy[0].tags"
              :key="index">
              {{ artistsBy[0].tags[tag] | uppercase }}
            </span>
          </div>-->
        </el-col>
        <el-col
          :xs="24"
          :sm="16"
          :md="17"
          :lg="18"
          :xl="18"
          class="apper-artist">
          <el-row>
            <el-col
              :span="24"
              class="title">
              <h1>Eventos en los que aparece <span>(<b>{{ quantifyOfPresentations }}</b> en total)</span></h1>
            </el-col>
            <el-col
              v-if="quantifyOfPresentations >=1"
              :span="24"
              class="content-card">
              <card
                v-for="item in eventOf"
                :category="item.category.parentId"
                :key="item.id"
                :data="item"/>
            </el-col>
            <el-col
              v-else
              :span="24"
              class="no-data-artist">
              <h1>No existen eventos donde participe este artista </h1>
            </el-col>
            <el-col class="slide-artist">
              <carousel
                :navigation-enabled="true"
                :scroll-per-page="true"
                :per-page-custom="[[600,1], [500,1], [400,1], [320,1]]"
                :pagination-size="8"
                class="slide-layout"
                pagination-active-color="#DE3745">
                <slide
                  v-for="item in eventOf"
                  :key="item.id">
                  <card
                    :category="item.category.parentId"
                    :data="item"/>
                </slide>
              </carousel>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import card from '../_shared/mt-card-event'
export default {
  name: 'ReadArtist',
  components: {
    card
  },
  props: {
    nameRoute: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      artist: {},
      eventArtist: [],
      numberOfEvents: [],
      eventOf: [],
      category: 0,
      quantifyOfPresentations: 0,
      fullscreenLoading: false
    }
  },
  computed: {
    backgroundImg () {
      return {
        backgroundImage: 'url(' + this.artist.coverImage + ')'
      }
    },
    profileImg () {
      return {
        backgroundImage: 'url(' + this.artist.profileImage + ')'
      }
    }
  },
  mounted () {
    this.fullscreenLoading = true
    Promise.all([
      this.$store.dispatch('artist/get', {id: this.$route.params.id, limit: 1000}),
      this.$store.dispatch('eventArtist/query', {'filters[where][artistId][eq]': this.$route.params.id, fields: 'eventId'})
    ]).then((response) => {
      this.artist = response[0].data
      this.eventArtist = response[1].data.items
      for (let i = 0; i < this.eventArtist.length; i++) {
        this.numberOfEvents.push(this.eventArtist[i].eventId)
      }
      this.$store.dispatch('events/query', {'filters[whereIn][id]': this.numberOfEvents, with: 'category'}).then((response) => {
        this.eventOf = response.data.items
        this.quantifyOfPresentations = this.eventOf.length
      })
    }).catch((e) => {
    }).finally(() => {
      this.fullscreenLoading = false
    })
  },
  methods: {
    fullColor (index) {
      if (this.progress[index].percentage > 0) {
        return this.progress[index].color
      }
    },
    goToBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>

  .no-data-artist{
    text-align: center;
    border-radius: 4px;
    color: $carbon;
    background-color: #eeeeee;
  }

  .artist-container{
    margin-top: 70px;
    position: relative;
    @media #{$Elementxs} {
      margin-top: 50px;
    }
  }

  .artist-banner{
    height: 300px;
    position: relative;
    background-size: cover;
    background-position: center;
    @media #{$iPhone} {
      height: 220px;
    }
    .name-artist{
      width: 1280px;
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      margin: 0 auto;
      h1{
        color: white;
        @include font-primary(36px, light);
      }
      @media #{$Laptop} {
        width: 100%;
        padding-left: 50px;
      }
      @media #{$NoteS} {
        padding-left: 20px;
      }
      @media #{$iPhone} {
        display: none;
      }
    }
  }
  .artist-description{
    background-color: white;
    height: auto;
    margin-right: 20px !important;
    padding: 50px 20px 20px 20px !important;
    @media #{$Elementxs} {
      border-radius: 2px;
      -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
    }
    @media #{$iPhoneSE} {
      position: relative;
      width: 100%;
      bottom: 100px;
    }
    .artist-img{
      border: 3px solid white;
      border-radius: 50%;
      width: 120px;
      height: 120px;
      margin: 0 auto;
      background-position: center;
      background-size: cover;
      box-shadow: 0 4px 25px 1px rgba(0, 0, 0, 0.2);
    }
    h1{
      @include font-primary(24px, light);
      color: $carbon;
    }
    p{
      margin-top: 50px;
      text-align: justify;
      @include font-primary(12px, light);
      color: $carbon;
    }
    .tag-event{
      margin-top: 5px;
    }
  }
  .content-card{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    .card-container {
      margin-bottom: 10px;
    }
    @media #{$NoteS} {
      display: none;
    }
  }

  .apper-artist{
    @media #{$iPhoneSE} {
      position: relative;
      top: -80px;
    }
    .el-row{
      width: 100%;
    }
    .title{
      height: 40px;
      border-bottom: 1px solid #E6E6E6;
      padding-left: 0 !important;
      margin-bottom: 29px;
      h1{
        margin: 0;
        @include font-primary(14px, semibold);
        color: #444444;
      }
      span{
        @include font-primary(14px, regular);
        color: #444444;
      }
    }
  }

  .btn-route {
    display: none;
    @media #{$NoteS} {
      display: flex;
      align-items: center;
      color: white;
      padding: 10px;
      i {
        font-size: 14px;
        line-height: 14px;
      }
      span {
        margin-left: 10px;
      }
    }
  }

  .div-img-artist{
    h1{
      display: none;
      margin-left: 10px;
      @media #{$iPhone} {
        display: block;
        color: $carbon;
      }
    }
    @media #{$iPhoneSE} {
      .artist-img{
        margin: 0;
        width: 80px !important;
        height: 70px !important;
      }
    }
    @media #{$iPhone} {
      .artist-img{
        margin: 0;
        width: 60px;
        height: 60px;
      }
      display: flex;
      align-items: center;
      width: 100%;
      height: auto;
      text-align: left !important;

    }
  }

  ///////////SLIDER/////////////
  .slide-artist{
    display: none;
    @media #{$NoteS} {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/artist/read-artist.vue